import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import './OverviewText.scss'

const OverviewText = ({ ui }) => {
  const OverviewText = ui.overviewText;
  const [isVisible, setIsVisible] = useState(true); // initially visible

  useEffect(() => {
    window.handleOverviewText = () => {
        setIsVisible(false);
    }
  });

  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <h3 id="OverviewText">
      {OverviewText}
    </h3>,
    document.getElementById("overviewText")
  );
};

export default OverviewText;
